import React from "react"
import ReactApexChart from "react-apexcharts"

const DonutChart = ({ data, type = "activity" }) => {
  // Configure chart based on type
  const getChartConfig = () => {
    if (type === "institution") {
      return {
        labels: ["Medical", "Engineering", "Law", "Arts", "Agriculture", "Management"],
        colors: ["#8E7CC3", "#29B6F6", "#E57373", "#8699ad", "#66BB6A", "#FFA726"],
        series: [
          data.medical || 0,
          data.engineering || 0,
          data.law || 0,
          data.arts || 0,
          data.agriculture || 0,
          data.management || 0,
        ],
        total: Object.values(data).reduce((sum, val) => sum + (val || 0), 0)
      }
    }
    
    // Default activity type
    return {
      labels: ["Universities", "Institutions", "Programs", "Courses"],
      colors: ["#8E7CC3", "#29B6F6", "#E57373", "#8699ad"],
      series: [
        data.universities || 0,
        data.institutions || 0,
        data.programs || 0,
        data.courses || 0,
      ],
      total: (data.universities || 0) + (data.institutions || 0) + (data.programs || 0) + (data.courses || 0)
    }
  }

  const config = getChartConfig()

  const chartOptions = {
    options: {
      chart: {
        type: "donut",
      },
      labels: config.labels,
      colors: config.colors,
      dataLabels: {
        enabled: false,
        formatter: function (val, opts) {
          return `${opts.w.globals.labels[opts.seriesIndex]}: ${val.toFixed(1)}%`
        },
        style: {
          fontSize: "14px",
          colors: ["#000"],
        },
      },
      legend: {
        show: true,
        position: "bottom",
      },
      plotOptions: {
        pie: {
          donut: {
            size: "70%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "Total",
                formatter: () => config.total,
              },
            },
          },
        },
      },
    },
  }

  return (
    <React.Fragment>
      {data && (
        <ReactApexChart
          options={chartOptions.options}
          series={config.series}
          type="donut"
          height="300"
        />
      )}
    </React.Fragment>
  )
}

export default DonutChart
